module.exports = __webpack_public_path__ + "static/media/buxton-6.702aa201.jpg";